import { CONSULTANT_PHONE_DIGITS, GROUNDED_PHONE_RULE } from '../core/contracts.js'

/** +47 optional, then exactly 8 digits with spaces/dots/dashes — not orgnr (9). */
const PHONE_CANDIDATE_RE = /(?:\+47[\s.-]?)?(?<!\d)(\d(?:[\s.-]?\d){7})(?!\d)/g

const CONSULTANT_SET = new Set<string>(CONSULTANT_PHONE_DIGITS)

export function normalizePhoneDigits(value: string): string {
  return value.replace(/\D/g, '')
}

export function isConsultantPhone(digits: string): boolean {
  return CONSULTANT_SET.has(digits)
}

/** Display grouping used on Norwegian mobiles (982 95 555). */
export function formatNorwegianPhone(digits: string): string {
  if (digits.length !== 8) return digits
  return `${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(5)}`
}

/**
 * Extract 8-digit Norwegian phones from grounded text.
 * Drops F.B/c / Farzad (94446446). Does not invent or rearrange.
 */
export function extractGroundedPhones(...texts: Array<string | null | undefined>): string[] {
  const found = new Set<string>()
  for (const text of texts) {
    if (!text) continue
    const re = new RegExp(PHONE_CANDIDATE_RE.source, 'g')
    for (const match of text.matchAll(re)) {
      let digits = normalizePhoneDigits(match[1] || match[0] || '')
      if (digits.startsWith('47') && digits.length === 10) digits = digits.slice(2)
      if (digits.length !== 8) continue
      if (isConsultantPhone(digits)) continue
      found.add(digits)
    }
  }
  return [...found]
}

/** Drop Norwegian phone candidates. Does not invent a replacement number. */
export function omitPhones(text: string): string {
  const re = new RegExp(PHONE_CANDIDATE_RE.source, 'g')
  return text
    .replace(re, '')
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/\s+([,.])/g, '$1')
    .trim()
}

export function containsPhone(text: string): boolean {
  const re = new RegExp(PHONE_CANDIDATE_RE.source)
  return re.test(text)
}

export function formatGroundedPhoneInstruction(phones: string[]): string {
  const list =
    phones.length > 0
      ? phones.map(formatNorwegianPhone).join(', ')
      : '(none in session evidence)'
  return `GROUNDED PHONES: ${list}\n${GROUNDED_PHONE_RULE}`
}
